import * as React from "react";

const Nav = ({ children }) => (
  <nav className="nav-sidebar">
    <ul className="nav tabs">{children}</ul>
  </nav>
);

export default Nav;



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/Nav.tsx